import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
export default class ManifestoComponent extends Component {
  get SELECTORS() {
    return {
      wrapper: '[data-manifesto]',
      section1: '[data-manifesto-first-section]',
      section2: '[data-manifesto-images]',
      chevronButton: '[data-manifesto-arrow]',
    };
  }
  get CSS_CLASSNAMES() {
    return {
      scrolled: 'scrolled',
    };
  }
  get COMPONENTNAME() {
    return 'ManifestoComponent';
  }
  constructor(htmlEl) {
    super(htmlEl);
    this.section1 = this.$component.querySelector(this.SELECTORS.section1);
    this.section2 = this.$component.querySelector(this.SELECTORS.section2);
    this.wrapper = this.$component.querySelector(this.SELECTORS.wrapper);
    this.scrollValue = null;
    this.performScroll = true;
    this.chevronButton = this.$component.querySelector(
      this.SELECTORS.chevronButton
    );
    this.offset = document.querySelector('.c-main-header').offsetHeight;
  }

  bindEvents() {
    this.chevronButton.addEventListener('click', () => {
      this.scrollImages(true);
    });
  }

  scrollImages(fromClick) {
    let distance = 0;
    if (
      this.wrapper.classList.contains(this.CSS_CLASSNAMES.scrolled) &&
      !fromClick
    ) {
      distance -= this.section1.offsetHeight;
      this.wrapper.classList.remove(this.CSS_CLASSNAMES.scrolled);
    } else {
      distance += this.section1.offsetHeight;
      if (!fromClick) {
        this.wrapper.classList.add(this.CSS_CLASSNAMES.scrolled);
      }
    }
    this.scrollDocumentTo(distance);
  }

  scrollDocumentTo(distance) {
    window.addEventListener('wheel', this.preventScroll, { passive: false });
    setTimeout(() => {
      if (this.performScroll) {
        this.scrollBy(distance, 1000);
      } else {
        window.removeEventListener('wheel', this.preventScroll);
      }
      this.performScroll = true;
    }, 200);
    setTimeout(() => {
      window.removeEventListener('wheel', this.preventScroll);
      this.performScroll = true;
    }, 1200);
  }

  setFirstScene() {
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.SELECTORS.wrapper,
      triggerHook: 0,
      offset: -this.offset,
      duration: this.section2.offsetHeight,
    });
    this.scene
      .setPin(this.SELECTORS.section1)
      .on('enter', () => {
        this.chevronButton.classList.add('opaque');
        this.scrollImages(false);
      })
      .on('leave', () => {
        if (this.scene.progress() == 0) {
          this.chevronButton.classList.remove('opaque');
          this.wrapper.classList.remove(this.CSS_CLASSNAMES.scrolled);
        } else {
          this.wrapper.classList.add(this.CSS_CLASSNAMES.scrolled);
        }
        this.performScroll = false;
        setTimeout(() => {
          this.performScroll = true;
        }, 500);
      })
      .addTo(this.controller);
  }

  scrollBy(distance, duration) {
    var initialY =
      document.documentElement.scrollTop || document.body.scrollTop;
    var y = initialY + distance;
    var baseY = (initialY + y) * 0.5;
    var difference = initialY - baseY;
    var startTime = performance.now();

    function step() {
      var normalizedTime = (performance.now() - startTime) / duration;
      if (normalizedTime > 1) normalizedTime = 1;

      window.scrollTo(
        0,
        baseY + difference * Math.cos(normalizedTime * Math.PI)
      );
      if (normalizedTime < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  render() {
    super.render();
    this.bindEvents();
    this.controller = new ScrollMagic.Controller();
    if (this.section2) {
      this.section2.style.top = `${this.section1.offsetHeight}px`;
      this.setFirstScene();
    }
  }

  preventScroll(e) {
    e.preventDefault();
    e.stopPropagation();

    return false;
  }
}
